(function () {
    /********************* Setup *********************/

        // find the header rendered by sections/theme-header.liquid
    const header = document.querySelector("#header");

    // exit on templates that don't render the header
    if (!header) {
        return;
    }

    const mobile = header.querySelector("#headerMobile");

    /********************* Desktop Dropdowns *********************/

    // close any open dropdown
    function closeDropdowns() {
        header.querySelectorAll(".headerNavItem.active").forEach(item => {
            item.classList.remove("active");
        });
    }

    // open dropdowns on hover, toggle on click for touch devices
    header.querySelectorAll(".headerNavItem[data-menu]").forEach(item => {
        item.querySelector(".headerNavItemLink").addEventListener("click", event => {
            event.preventDefault();
            event.stopPropagation();
            const wasOpen = item.classList.contains("active");
            closeDropdowns();
            if (!wasOpen) {
                item.classList.add("active");
            }
        });
        item.addEventListener("mouseenter", () => {
            closeDropdowns();
            item.classList.add("active");
        });
        item.addEventListener("mouseleave", () => {
            item.classList.remove("active");
        });
    });

    // clicking anywhere outside the nav closes open dropdowns
    document.addEventListener("click", closeDropdowns);

    /********************* Mobile Overlay *********************/

    // show the overlay and lock page scroll
    function openMobile() {
        mobile.classList.add("active");
        document.body.classList.add("noScroll");
    }

    // hide the overlay and restore page scroll
    function closeMobile() {
        mobile.classList.remove("active");
        document.body.classList.remove("noScroll");
    }

    header.querySelector("#headerHamburger").addEventListener("click", openMobile);
    header.querySelector("#headerMobileTopClose").addEventListener("click", closeMobile);

    /********************* Mobile Tabs *********************/

    // switch the active tab and its matching panel
    header.querySelectorAll(".headerMobileTabsItem").forEach(tab => {
        tab.addEventListener("click", () => {
            header.querySelectorAll(".headerMobileTabsItem.active, .headerMobilePanel.active").forEach(element => {
                element.classList.remove("active");
            });
            tab.classList.add("active");
            header.querySelector(`.headerMobilePanel[data-panel="${tab.dataset.panel}"]`).classList.add("active");
        });
    });

    /********************* Escape Key *********************/

    // escape closes dropdowns and the mobile overlay
    document.addEventListener("keydown", event => {
        if (event.key !== "Escape") {
            return;
        }
        closeDropdowns();
        closeMobile();
    });
}());
